import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { CircularProgress } from "@material-ui/core";

import MakeAPICall from "../../apiCalls/common";

import { getTicketsWithFilterApiRoute } from "../../apiRoutes";

import ICInput from "../../components/form/input";

// name-only patient search, reusable wherever a ticket's patient needs to be looked up/changed
const PatientSearch = props => {
  const [apiCallParams, setApiCallParams] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchText, setSearchText] = useState(props.initialName || "");
  const [patientList, setPatientList] = useState([]);
  const [loading, setLoading] = useState(false);

  let searchInterval = useRef();

  // tickets can repeat the same patient across multiple tickets, so dedupe by patient _id
  const getUniquePatients = tickets => {
    const seen = {};
    const patients = [];

    tickets.forEach(ticket => {
      const patient = ticket.patientId;
      if (patient && patient._id && !seen[patient._id]) {
        seen[patient._id] = true;
        patients.push(patient);
      }
    });

    return patients;
  };

  const setSearchInputVal = val => {
    clearTimeout(searchInterval.current);
    setSearchText(val);

    searchInterval.current = setTimeout(() => {
      if (val && val.trim().length > 0) {
        setSearchOpen(true);
        setLoading(true);

        setApiCallParams({
          reqType: "GET",
          reqUrl: getTicketsWithFilterApiRoute,
          params: { text: val, filterType: "patientName", skip: 0, limit: 10 },
          successCallback: res => {
            setLoading(false);
            const patients = getUniquePatients(res.data.data.tickets || []);
            setPatientList(patients);
            if (patients.length === 0) {
              setSearchOpen(false);
            }
          },
          failureCallback: () => {
            setLoading(false);
            setSearchOpen(false);
          }
        });
      } else {
        setSearchOpen(false);
        setPatientList([]);
      }
    }, 1000);
  };

  const selectPatient = patient => {
    setSearchText(patient.firstName + " " + patient.lastName);
    setSearchOpen(false);
    setPatientList([]);
    props.onSelectPatient({
      id: patient._id,
      patientId: patient.patientId,
      firstName: patient.firstName,
      lastName: patient.lastName
    });
  };

  return (
    <div className="position-relative">
      <ICInput
        name="patientSearch"
        type="text"
        label="Search patient by name..."
        value={searchText}
        onChange={e => setSearchInputVal(e.target.value)}
      />
      {searchOpen && (
        <div className="custom-dropdown-search-list">
          {loading && (
            <div className="list-loader">
              <CircularProgress disableShrink className="primary-loader" />
            </div>
          )}
          {!loading && patientList && patientList.length > 0 && (
            <ul>
              {patientList.map((item, index) => (
                <li onClick={() => selectPatient(item)} key={index}>
                  <div className="item-container">
                    <p className="name">
                      {item.firstName} {item.lastName}
                    </p>
                    <p>UIN:&nbsp;{item.patientId}</p>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

export default PatientSearch;

PatientSearch.propTypes = {
  initialName: PropTypes.string,
  onSelectPatient: PropTypes.func.isRequired
};
